module.exports = __webpack_public_path__ + "img/dai.44504b1d.png";